export const extractImageFilesFromClipboardEvent = (event) => {
    if (!event?.clipboardData) {
        return [];
    }

    const { clipboardData } = event;
    const files = [];

    const pushIfImage = (file) => {
        if (file && (!file.type || file.type.startsWith("image/"))) {
            files.push(file);
        }
    };

    const items = clipboardData.items ? Array.from(clipboardData.items) : [];
    items.forEach((item) => {
        if (item?.kind === "file") {
            pushIfImage(item.getAsFile());
        }
    });

    if (!files.length && clipboardData.files?.length) {
        Array.from(clipboardData.files).forEach(pushIfImage);
    }

    return files;
};

const copyTextWithTextareaFallback = (text) => {
    if (
        typeof document === "undefined"
        || !document.body
        || typeof document.execCommand !== "function"
    ) {
        return false;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.width = "1px";
    textarea.style.height = "1px";
    textarea.style.opacity = "0";
    textarea.style.pointerEvents = "none";

    const selection = document.getSelection?.();
    const previousRange = selection && selection.rangeCount > 0
        ? selection.getRangeAt(0).cloneRange()
        : null;

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    let copied = false;
    try {
        copied = document.execCommand("copy");
    } finally {
        document.body.removeChild(textarea);
        if (selection) {
            selection.removeAllRanges();
            if (previousRange) {
                selection.addRange(previousRange);
            }
        }
    }

    return copied;
};

export const copyTextToClipboard = async (value) => {
    const text = typeof value === "string" ? value : "";
    if (!text) {
        throw new Error("Clipboard text must be a non-empty string.");
    }

    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (_) {
            // The async clipboard API can be unavailable despite existing,
            // for example in non-secure contexts. Try the gesture-bound path.
        }
    }

    if (copyTextWithTextareaFallback(text)) {
        return true;
    }

    throw new Error("Unable to copy text to clipboard.");
};

export default extractImageFilesFromClipboardEvent;
